import React, { Suspense, Fragment } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { getData } from '../../common/services/network.service';
import advancedFeaturesEventsManager from '../../common/events/advancedFeaturesEvents';

export const CLASS_ADVANCED_FEATURE_INDICATION_PLACEHOLDER = 'ti-advanced-feature';
export const CLASS_ADVANCED_FEATURE_INDICATION_RENDERED = 'ti-advanced-feature-indication';
export const ATTRIBUTE_IS_INITIALIZED = 'isInitialized';
const GET_ADVANCED_FEATURES_DATA_API = 'contentProvider/GetAdvancedFeaturesInitialData';

let translationsStore: any = {};

const AdvancedFeatureIndicator = React.lazy(() =>
    import(
        /* webpackChunkName: "AdvancedFeatureIndicator" */ '../components/AdvancedFeatureIndicator/AdvancedFeatureIndicator'
        )
);
const AdvancedFeatureBadge = React.lazy(() =>
    import(/* webpackChunkName: "AdvancedFeatureBadge" */ '../components/AdvancedFeatureBadge/AdvancedFeatureBadge')
);

function renderAllIndicationsOnPage() {
    const advancedFeatureIndicationPlaceholders = document.getElementsByClassName(
        CLASS_ADVANCED_FEATURE_INDICATION_PLACEHOLDER
    );
    Array.from(advancedFeatureIndicationPlaceholders).forEach((el) =>
        renderAdvancedFeatureIndication(el as HTMLElement, {}, translationsStore)
    );
}

function isTranslationsReady() {
    return Object.keys(translationsStore).length > 0;
}

function getTranslations(baseUrl: string, callback: Function) {
    getData(
        `${baseUrl}${GET_ADVANCED_FEATURES_DATA_API}`,
        ({ translations }: any) => {
            translationsStore = {
                ...translations,
            };
            callback?.();
        },
        error => {
            console.log(error); //eslint-disable-line
        }
    );
}

function onTranslationsReady() {
    advancedFeaturesEventsManager.dispatchTranslationsLoaded();
    renderAllIndicationsOnPage();
}

export function initAdvancedFeaturesIndications(baseUrl: string = '', useTranslationsStore: boolean = true) {
    if (useTranslationsStore && isTranslationsReady()) {
        onTranslationsReady();
    } else {
        getTranslations(baseUrl, () => {
            onTranslationsReady();
        });
    }
}

export function destroyAdvancedFeatureIndications(): Element[] {
    const domElements = [...Array.from(document.getElementsByClassName(CLASS_ADVANCED_FEATURE_INDICATION_RENDERED))];
    domElements.forEach(domEl => {
        domEl.removeAttribute(ATTRIBUTE_IS_INITIALIZED);
        domEl.classList.remove(CLASS_ADVANCED_FEATURE_INDICATION_RENDERED);
        unmountComponentAtNode(domEl);
    });
    return domElements;
}


function renderAdvancedFeatureComponent(options: any) {
    if (isTranslationsReady()) {
        options?.render?.();
        return;
    }

    if (options?.baseUrl) {
        getTranslations(options.baseUrl, () => {
            onTranslationsReady();
            options.render?.();
        });
    }
}

export function renderAdvancedFeatureIndication(targetDomElement: HTMLElement, options: any = {}, baseUrl: string = '') {

    if (!(targetDomElement?.hasAttribute(ATTRIBUTE_IS_INITIALIZED) ?? true)) {
        renderAdvancedFeatureComponent({
            baseUrl,
            render: function () {
                render(
                    <Suspense fallback={<Fragment />}>
                        <AdvancedFeatureIndicator
                            description={
                                translationsStore.TI2020_ContentTranslations_AdvancedFeatures_AdvancedTooltipDescription
                            }
                            actionText={
                                translationsStore.TI2020_ContentTranslations_AdvancedFeatures_AdvancedTooltipButton
                            }
                            {...targetDomElement.dataset}
                            {...options}
                        />
                    </Suspense>,
                    targetDomElement
                );
                targetDomElement.classList.add(CLASS_ADVANCED_FEATURE_INDICATION_RENDERED);
                targetDomElement.setAttribute(ATTRIBUTE_IS_INITIALIZED, 'true');
            },
        });
    }
}

export function renderAdvancedFeatureBadge(targetDomElement: HTMLElement, options = {}, baseUrl: string = '') {
    if (!(targetDomElement?.hasAttribute(ATTRIBUTE_IS_INITIALIZED) ?? true)) {
        renderAdvancedFeatureComponent({
            baseUrl,
            render: function () {
                render(
                    <Suspense fallback={<Fragment />}>
                        <AdvancedFeatureBadge
                            name={translationsStore.TI2020_ContentTranslations_AdvancedFeatures_New}
                            {...targetDomElement.dataset}
                            {...options}
                        />
                    </Suspense>,
                    targetDomElement
                );
                targetDomElement.setAttribute(ATTRIBUTE_IS_INITIALIZED, 'true');
            },
        });
    }
}

export const getAdvancedFeaturesTranslationStore = () => translationsStore;
